import React, { useState } from 'react';

const templateCategories = ['全部', '旅游', '数码', '穿搭', '美食', '职场'];

const templates = [
  {
    id: 1,
    title: '保姆级旅游攻略',
    desc: '包含交通/住宿/避坑/路线全流程',
    usage: '1.2w+',
    tag: '旅游',
    icon: '🗺️',
    image: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80',
    detailDesc: '这套模板专为旅游博主设计，涵盖了从行程规划、交通/住宿预订、景点避坑指南到地道美食推荐的全流程。\n\n结构清晰，重点突出，能够帮助读者快速获取当地旅游的核心信息，是打造爆款小红书干货旅游笔记的实战必备经验。'
  },
  {
    id: 2,
    title: '好物深度测评',
    desc: '多维度对比/真实槽点/红黑榜',
    usage: '8.4k',
    tag: '数码',
    icon: '💻',
    image: 'https://images.unsplash.com/photo-1525547719571-a2d4ac8945e2?w=800&q=80',
    detailDesc: '深度的产品客观测评模板，适用于数码、家电等类目。文章结构包括：外观设计、核心参数剖析、性能跑分、日常体验感受以及优缺点总结（红黑榜）。\n\n通过多维度横向对比，打造客观中立的专业人设，大幅提升粉丝信任度和种草转化率。'
  },
  {
    id: 3,
    title: '沉浸式探店日记',
    desc: '氛围感拉满/环境+菜品点评',
    usage: '5.2k',
    tag: '美食',
    icon: '🥘',
    image: 'https://images.unsplash.com/photo-1549488344-c5a45b80a6b7?w=800&q=80',
    detailDesc: '第一视角的高级感探店写作框架。从店面门头的第一视觉冲击、内部环境氛围、出片最佳拍照点位，到底消服务和招牌菜品口感进行逐一点评。\n\n兼顾实用探店信息和小资情调，迅速吸引本地吃货群体打卡收藏。'
  },
  {
    id: 4,
    title: 'OOTD穿搭分享',
    desc: '品牌标注/身高参考/风格解析',
    usage: '15k+',
    tag: '穿搭',
    icon: '👗',
    image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&q=80',
    detailDesc: '穿搭博主必备的高转化结构模板。要求精确到博主身高体重信息、全身单品品牌及价格列表、同色系搭配法则与拍照姿势建议。\n\n结构干脆利落，让每一套OOTD都具有极强的落地参考价值，增加粉丝粘性。'
  },
  {
    id: 5,
    title: '职场生存指南',
    desc: '高情商回复/效率工具/晋升心得',
    usage: '3.1k',
    tag: '职场',
    icon: '💼',
    image: 'https://images.unsplash.com/photo-1497032205916-ac53390f4b1f?w=800&q=80',
    detailDesc: '直击打工人痛点的职场干货分享框架。包含经典的高情商话术实操解析、办公效率神器评测安利，以及向上管理等核心职场思维拔高分享。\n\n帮助用户迅速搭建专业、通透的职场精英IP定位。'
  },
  {
    id: 6,
    title: '减脂食谱日记',
    desc: '热量标注/简单易做/阶段性反馈',
    usage: '9.8k',
    tag: '美食',
    icon: '🥑',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80',
    detailDesc: '深受年轻受众喜爱的高颜值、低卡路里减脂餐分享模板。涵盖详实的食材购买清单、清晰的营养热量表、极简做法步骤及减脂期的饮食心态调整。\n\n传递自律的美好健康生活方式，引发强烈的共鸣和模仿冲动。'
  },
];

/* Detail Modal Component */
const TemplateDetailModal = ({ template, onClose, onApply }) => {
  if (!template) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm animate-fade-in" onClick={onClose}>
      <div
        className="relative w-full max-w-2xl overflow-hidden rounded-[24px] bg-white shadow-2xl animate-scale-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-black/30 text-white backdrop-blur-md transition-colors hover:bg-black/50"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>

        <div className="relative h-64 w-full">
          <img src={template.image} alt={template.title} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent" />
          <div className="absolute bottom-6 left-8 flex items-end gap-5">
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white/10 text-3xl shadow-lg ring-1 ring-white/20 backdrop-blur-md">
              {template.icon}
            </div>
            <div className="mb-1 text-white">
              <div className="flex items-center gap-3 mb-2">
                <span className="rounded-full bg-[#2563EB] px-3 py-1 text-xs font-bold shadow-sm">
                  {template.tag}
                </span>
                <span className="flex items-center gap-1.5 text-sm font-medium text-white/90">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z" /><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" /></svg>
                  {template.usage} 使用
                </span>
              </div>
              <h2 className="text-3xl font-black tracking-wide">{template.title}</h2>
            </div>
          </div>
        </div>

        <div className="p-8">
          <h3 className="mb-3 text-lg font-bold text-gray-900">模板介绍</h3>
          <p className="text-[15px] leading-relaxed text-gray-600 mb-8 whitespace-pre-line">
            {template.detailDesc}
          </p>

          <h3 className="mb-3 text-lg font-bold text-gray-900">适用场景与特点</h3>
          <ul className="mb-8 space-y-3">
            <li className="flex items-start gap-3 text-[15px] text-gray-600">
              <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600">
                <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" /></svg>
              </div>
              {template.desc}
            </li>
            <li className="flex items-start gap-3 text-[15px] text-gray-600">
              <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600">
                <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
              </div>
              高效结构化输出，直接提高成文速度与质量
            </li>
          </ul>

          <div className="flex gap-4 pt-4 border-t border-gray-100">
            <button
              onClick={onClose}
              className="flex-1 rounded-xl bg-gray-50 py-3.5 font-bold text-gray-700 transition-colors hover:bg-gray-100"
            >
              取消
            </button>
            <button
              onClick={() => { onClose(); onApply(template); }}
              className="flex-[2] rounded-xl bg-gray-900 py-3.5 font-bold text-white shadow-lg shadow-gray-200 transition-all hover:bg-[#2563EB] hover:shadow-xl hover:shadow-[#2563EB]/20"
            >
              使用基础模板
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const SkillsPage = ({ onApplyTemplate }) => {
  const [activeTemplateCat, setActiveTemplateCat] = useState('全部');
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  return (
    <div className="animate-fade-in min-h-screen bg-[#F8FAFC] p-6 pt-10 relative">
      <div className="mx-auto max-w-6xl space-y-10">
        <div className="mb-12 space-y-3 text-center">
          <h1 className="text-4xl font-black text-gray-900">爆款内容模板</h1>
          <p className="font-medium text-gray-400">百万博主亲测有效的结构化写作框架</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {templateCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveTemplateCat(cat)}
              className={`rounded-full px-6 py-2.5 text-sm font-bold transition-all ${activeTemplateCat === cat
                ? 'bg-[#2563EB] text-white shadow-lg shadow-[#2563EB]/20'
                : 'border border-gray-100 bg-white text-gray-500 hover:border-[#2563EB]/30'
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {templates
            .filter((item) => activeTemplateCat === '全部' || item.tag === activeTemplateCat)
            .map((template) => (
              <div
                key={template.id}
                className="group relative flex h-full cursor-pointer flex-col overflow-hidden rounded-[24px] border border-gray-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-blue-100"
                onClick={() => setSelectedTemplate(template)}
              >
                <div className="relative h-48 w-full overflow-hidden">
                  <img src={template.image} alt={template.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-xl bg-white/90 text-xl shadow-sm backdrop-blur-sm">
                    {template.icon}
                  </div>
                  <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                    <span className="rounded-full bg-white/20 px-3 py-1 text-xs font-medium text-white shadow-sm backdrop-blur-md">
                      {template.tag}
                    </span>
                    <span className="flex items-center gap-1 text-xs font-medium text-white/90 drop-shadow-md">
                      <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z" /><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" /></svg>
                      {template.usage}
                    </span>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6">
                  <h3 className="mb-2 text-xl font-bold text-gray-900 transition-colors group-hover:text-[#2563EB]">{template.title}</h3>
                  <p className="mb-6 line-clamp-2 text-sm leading-relaxed text-gray-500">{template.desc}</p>

                  <div className="mt-auto">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onApplyTemplate?.(template);
                      }}
                      className="w-full rounded-xl bg-gray-50 py-3 font-semibold text-gray-700 transition-colors hover:bg-[#2563EB] hover:text-white"
                    >
                      直接使用
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <TemplateDetailModal
        template={selectedTemplate}
        onClose={() => setSelectedTemplate(null)}
        onApply={onApplyTemplate}
      />
    </div>
  );
};

export default SkillsPage;
